module.exports = __webpack_public_path__ + "img/step2.8400c4bf.svg";